import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { useStoreState } from 'pullstate'
import _ from 'lodash'
import CONSTANTS from 'libs/backendStringConstants'

import UIStore from 'states/globalStore'
import RolesAccessMatrix from './RolesAccessMatrix'
import backendChecks from '../../libs/backendChecks'

function hasSimpleRouteMatching(routes, pathname) {
  return routes.includes(pathname)
}

function hasParameterizedRouteMatching(parameterisedRoutes, pathname) {
  const matchedRoutes = parameterisedRoutes.filter(pRoutesRegex => {
    return pRoutesRegex.test(pathname)
  })
  return !_.isEmpty(matchedRoutes)
}

const AccessCheck = props => {
  const { children } = props

  const { userProfile } = useStoreState(UIStore, s => ({
    userProfile: s.userProfile
  }))

  const { pathname } = useLocation()

  if (_.isEmpty(userProfile)) {
    return children({ isProfileLoading: true })
  }

  const userRoles = backendChecks.getUserRoles(userProfile)
  let isAuthorized = false

  const hasValidRoles = [
    CONSTANTS.HEALTHWORKER,
    CONSTANTS.ADMIN,
    CONSTANTS.RADIOLOGIST
  ].some(role => {
    return userRoles.includes(role)
  })

  if (!hasValidRoles) {
    isAuthorized = false
  } else {
    const {
      parameterisedRoutes: commonParameterisedRoutes,
      routes: commonRoutes
    } = RolesAccessMatrix.common
    const isCommonRoute =
      hasSimpleRouteMatching(commonRoutes, pathname) ||
      hasParameterizedRouteMatching(commonParameterisedRoutes, pathname)

    const hasAccess = userRoles.some(userRole => {
      const { parameterisedRoutes, routes } = RolesAccessMatrix[userRole]
      return (
        hasSimpleRouteMatching(routes, pathname) ||
        hasParameterizedRouteMatching(parameterisedRoutes, pathname)
      )
    })

    isAuthorized = isCommonRoute || hasAccess
  }

  return children({ isAuthorized })
}

AccessCheck.propTypes = {
  children: PropTypes.func.isRequired
}

export default AccessCheck
